<app-header *ngIf="!appSettings.appHideGlobalHeader()"></app-header>

<div
  class="app-layout"
  [ngClass]="{
    'full-screen': appSettings.appEmpty(),
    'has-global-header': !appSettings.appHideGlobalHeader(),
  }"
>
  <app-sidebar *ngIf="!appSettings.appEmpty()"></app-sidebar>

  <div
    id="content"
    [ngClass]="{
      'p-0': appSettings.appEmpty(),
      'm-0': appSettings.appEmpty(),
      'app-content': !appSettings.appEmpty(),
    }"
  >
    <router-outlet></router-outlet>
  </div>
</div>
